export enum Language {
  EN = 'en',
  CZ = 'cz',
  SK = 'sk',
  PL = 'pl',
  HU = 'hu',
  RO = 'ro'
}
